<template>
  <div style="display: flex; flex-direction: row; flex-wrap: wrap; gap: 0.5rem">
    <div v-for="article in filteredArticles" :key="article.number" :style="barcodeWrapperStyles">
      <div :style="barcodeUpperStyles">
        <h1 :style="[resetStyles, barcodeTitleStyles]" name="articleNumber">
          {{ article.number }}
        </h1>
        <Barcode :value="article.number" :options="{ displayValue: false, height: 38, margin: 0 }" />
      </div>
      <div :style="barcodeLowerStyles">
        <p name="articleName" :style="[resetStyles, barcodeNameStyles]">
          {{ getArticleName(article) }}
        </p>
        <p name="salesUnit" :style="resetStyles">{{ article.unit }}</p>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
type Article = {
  number: string;
  name: string;
  unit: string;
};

type Props = {
  articles: Article[];
};

const props = withDefaults(defineProps<Props>(), {
  articles: () => [],
});

const filteredArticles = computed(() => {
  return props.articles.filter((article) => article.number);
});

const getArticleName = (article: Article) => {
  return article.name?.length > maxStringLength ? `${article.name.substring(0, maxStringLength)}..` : article.name;
};
</script>

<script lang="ts">
const maxStringLength = 52;
const leftMargins = '11px';
const resetStyles = ref({
  margin: '0px',
});
const barcodeWrapperStyles = ref({
  width: '397px',
  height: '96px',
  border: '1px dashed #000',
  padding: '11px',
  display: 'flex',
  'flex-flow': 'column',
  'justify-content': 'space-between',
  'box-sizing': 'border-box',
  'break-inside': 'avoid',
});

const barcodeUpperStyles = ref({
  display: 'flex',
  'justify-content': 'space-between',
});

const barcodeLowerStyles = ref({
  display: 'flex',
  'justify-content': 'space-between',
  'font-size': '1rem',
  'font-weight': '700',
});

const barcodeTitleStyles = ref({
  width: '121px',
  'margin-left': leftMargins,
  'font-size': '1.9rem',
  display: 'flex',
  'align-items': 'center',
});
const barcodeNameStyles = ref({
  'margin-left': leftMargins,
});
</script>
